/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Verification Status
 */
export type GetBankAccountsResponseVerificationStatus = typeof GetBankAccountsResponseVerificationStatus[keyof typeof GetBankAccountsResponseVerificationStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBankAccountsResponseVerificationStatus = {
  verified: 'verified',
  pending: 'pending',
  failed: 'failed',
} as const;
